import { usePageTitle } from '../hooks/usePageTitle';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const GUNLER = ['Pzt','Sal','Çar','Per','Cum','Cmt','Paz'];
const SEVIYELER = ['Başlangıç','Orta','İleri','Tüm seviyeler'];
const SR: any = {
  'Baslangic':{bg:'#EAF3DE',tc:'#3B6D11'},
  'Orta':{bg:'#EEEDFE',tc:'#3C3489'},
  'Ileri':{bg:'#FCEBEB',tc:'#A32D2D'},
  'Tum seviyeler':{bg:'#f0f0f0',tc:'#666'}
};

const Dersler: React.FC = () => {
  usePageTitle('Dersler');
  const navigate = useNavigate();
  const location = useLocation();
  const { kullanici } = useAuth();
  const { isDark } = useTheme();
  const card        = isDark ? '#1a1a1a' : 'white';
  const cardAlt     = isDark ? '#1e1e1e' : '#f8f8f8';
  const cardHover   = isDark ? '#252525' : '#fafafa';
  const border      = isDark ? '#2a2a2a' : '#eee';
  const borderSub   = isDark ? '#202020' : '#f0f0f0';
  const textPrimary = isDark ? '#e8e8e8' : '#1a1a1a';
  const textSec     = isDark ? '#999'    : '#888';
  const textMuted   = isDark ? '#666'    : '#aaa';
  const [dersler, setDersler] = useState<any[]>([]);
  const [salonlar, setSalonlar] = useState<any[]>([]);
  const [tumEgitmenler, setTumEgitmenler] = useState<any[]>([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modal, setModal] = useState(false);
  const [duzenle, setDuzenle] = useState<any>(null);
  const [hata, setHata] = useState('');
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [arsivModal, setArsivModal] = useState(false);
  const [arsivDersler, setArsivDersler] = useState<any[]>([]);
  const [arsivYukleniyor, setArsivYukleniyor] = useState(false);
  const boslForm = { ad:'', seviye:'Başlangıç', salon_id:'', kapasite:15, aciklama:'', kayit_acik:true };
  const [form, setForm] = useState(boslForm);
  const [seanslar, setSeanslar] = useState<any[]>([]);
  const [dersEgitmenleri, setDersEgitmenleri] = useState<any[]>([]);
  const [yeniSeans, setYeniSeans] = useState({ gun:'Pzt', baslangic_saat:'18:00', bitis_saat:'19:30' });
  const [yeniEgitmen, setYeniEgitmen] = useState({ egitmen_id:'', hakedis_oran:0 });

  const yukle = () => {
    setYukleniyor(true);
    Promise.all([api.get('/api/dersler'), api.get('/api/salonlar'), api.get('/api/egitmenler')])
      .then(([d,s,e]) => { setDersler(d.data); setSalonlar(s.data); setTumEgitmenler(e.data); })
      .finally(() => setYukleniyor(false));
  };
  useEffect(() => { yukle(); }, []);

  // DersDetay'dan "Düzenle" tıklanınca gelen duzenleId state'ini yakala
  useEffect(() => {
    const duzenleId = (location.state as any)?.duzenleId;
    if (!duzenleId || dersler.length === 0 || modal) return;
    const ders = dersler.find((d: any) => d.id === duzenleId);
    if (ders) {
      ac(ders);
      window.history.replaceState({}, document.title);
    }
  }, [dersler, location.state]);

  const ac = (d?: any) => {
    setDuzenle(d||null);
    setForm(d ? { ad:d.ad, seviye:d.seviye, salon_id:d.salon_id||'', kapasite:d.kapasite, aciklama:d.aciklama||'', kayit_acik:d.kayit_acik !== false } : boslForm);
    setSeanslar(d?.seanslar||[]);
    setDersEgitmenleri(d?.egitmenler||[]);
    setYeniEgitmen({ egitmen_id:'', hakedis_oran:0 });
    setHata(''); setModal(true);
  };

  const seansEkle = () => {
    if (seanslar.find(s=>s.gun===yeniSeans.gun&&s.baslangic_saat===yeniSeans.baslangic_saat)) { setHata('Bu seans zaten ekli'); return; }
    setSeanslar(p=>[...p,{...yeniSeans}]); setHata('');
  };

  const egitmenEkle = () => {
    if (!yeniEgitmen.egitmen_id) { setHata('Egitmen secin'); return; }
    if (dersEgitmenleri.find(e=>e.egitmen_id===yeniEgitmen.egitmen_id)) { setHata('Bu egitmen zaten eklendi'); return; }
    const egitmen = tumEgitmenler.find(e=>e.id===yeniEgitmen.egitmen_id);
    setDersEgitmenleri(p=>[...p,{ egitmen_id:yeniEgitmen.egitmen_id, egitmen_adi: egitmen ? egitmen.ad+' '+egitmen.soyad : '', hakedis_oran:yeniEgitmen.hakedis_oran }]);
    setYeniEgitmen({ egitmen_id:'', hakedis_oran:0 });
    setHata('');
  };

  const kaydet = async () => {
    if (!form.ad) { setHata('Ders adi zorunlu'); return; }
    if (!form.salon_id) { setHata('Salon secimi zorunlu'); return; }
    setKaydediliyor(true); setHata('');
    try {
      const data = { ...form, seanslar, egitmenler: dersEgitmenleri, salon_id:form.salon_id||null };
      if (duzenle) await api.put(`/api/dersler/${duzenle.id}`, data);
      else await api.post('/api/dersler', data);
      setModal(false); yukle();
    } catch (err:any) { setHata(err.response?.data?.hata||'Hata olustu'); }
    finally { setKaydediliyor(false); }
  };

  const sil = async (id:string) => {
    if (!window.confirm('Bu dersi silmek istediginize emin misiniz?')) return;
    try { await api.delete(`/api/dersler/${id}`); yukle(); }
    catch (err:any) { alert(err.response?.data?.hata||'Silinemedi'); }
  };

  const arsivAc = async () => {
    setArsivModal(true);
    setArsivYukleniyor(true);
    try { const r = await api.get('/api/dersler/arsiv'); setArsivDersler(r.data); }
    catch { setArsivDersler([]); }
    finally { setArsivYukleniyor(false); }
  };

  const kaliciSil = async (id:string, ad:string) => {
    if (!window.confirm(`"${ad}" dersi ve tüm yoklama kayıtları kalıcı olarak silinecek. Bu işlem geri alınamaz. Devam edilsin mi?`)) return;
    try {
      await api.delete(`/api/dersler/${id}/kalici`);
      setArsivDersler(p => p.filter(d => d.id !== id));
    } catch (err:any) { alert(err.response?.data?.hata||'Silinemedi'); }
  };

  return (
    <div style={{ padding:24 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <h1 style={{ fontSize:22, fontWeight:600, margin:0 }}>Dersler ve program</h1>
        <div style={{ display:'flex', gap:8 }}>
          <button onClick={arsivAc} style={{ background:card, color:textSec, border:`1px solid ${border}`, padding:'8px 16px', borderRadius:6, cursor:'pointer', fontSize:13 }}>Silinen dersler</button>
          <button onClick={() => ac()} style={{ background:'#534AB7', color:'white', border:'none', padding:'8px 16px', borderRadius:6, cursor:'pointer', fontSize:13 }}>+ Yeni ders</button>
        </div>
      </div>

      {yukleniyor ? <div style={{ textAlign:'center', color:textSec, padding:40 }}>Yukleniyor...</div> : (
        <div style={{ background:card, borderRadius:10, border:`1px solid ${border}`, overflow:'hidden' }}>
          {dersler.length===0 ? <div style={{ padding:40, textAlign:'center', color:textMuted }}>Henuz ders eklenmedi.</div> : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
              <thead><tr style={{ borderBottom:`1px solid ${border}` }}>
                {['Ders','Seviye','Egitmenler','Salon','Seanslar','İlk Ders','Kayıt','Kayitli',''].map(h=>(
                  <th key={h} style={{ textAlign:'left', padding:'8px 14px', fontSize:11, color:textMuted, fontWeight:500 }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {dersler.map((d,i) => {
                  const sr = SR[d.seviye]||{bg:'#f0f0f0',tc:'#666'};
                  return (
                    <tr key={d.id} onClick={() => navigate(`/dersler/${d.id}`)} style={{ borderBottom:i<dersler.length-1?`1px solid ${borderSub}`:'none', cursor:'pointer' }}>
                      <td style={{ padding:'10px 14px', fontWeight:500 }}>{d.ad}</td>
                      <td style={{ padding:'10px 14px' }}><span style={{ background:sr.bg, color:sr.tc, borderRadius:20, padding:'2px 8px', fontSize:11 }}>{d.seviye}</span></td>
                      <td style={{ padding:'10px 14px' }}>
                        <div style={{ display:'flex', flexWrap:'wrap', gap:3 }}>
                          {d.egitmenler?.map((e:any,ei:number)=>(
                            <span key={ei} style={{ background:isDark ? 'rgba(83,74,183,0.2)' : '#EEEDFE', color:'#3C3489', borderRadius:20, padding:'2px 8px', fontSize:11 }}>
                              {e.egitmen_adi} %{e.hakedis_oran}
                            </span>
                          ))}
                          {(!d.egitmenler||d.egitmenler.length===0) && <span style={{ color:'#e24b4a', fontSize:11 }}>Atanmadi</span>}
                        </div>
                      </td>
                      <td style={{ padding:'10px 14px', color:isDark ? '#bbb' : '#555', fontSize:12 }}>{d.salon_adi||'--'}</td>
                      <td style={{ padding:'10px 14px' }}>
                        <div style={{ display:'flex', flexWrap:'wrap', gap:3 }}>
                          {d.seanslar?.map((s:any,si:number)=>(
                            <span key={si} style={{ background:isDark ? '#222222' : '#f0f0f0', color:isDark ? '#bbb' : '#555', borderRadius:20, padding:'1px 7px', fontSize:10 }}>{s.gun} {String(s.baslangic_saat).slice(0,5)}</span>
                          ))}
                        </div>
                      </td>
                      <td style={{ padding:'10px 14px', color:isDark ? '#bbb' : '#555', fontSize:12, whiteSpace:'nowrap' }}>
                        {d.ilk_ders_tarihi
                          ? new Date(d.ilk_ders_tarihi).toLocaleDateString('tr-TR', { day:'numeric', month:'short', year:'numeric' })
                          : <span style={{ color:isDark ? '#444' : '#ccc' }}>—</span>}
                      </td>
                      <td style={{ padding:'10px 14px' }} onClick={e => e.stopPropagation()}>
                        <button
                          onClick={async () => {
                            try {
                              await api.patch(`/api/dersler/${d.id}/kayit-durumu`, { kayit_acik: !d.kayit_acik });
                              yukle();
                            } catch { alert('Güncellenemedi'); }
                          }}
                          style={{
                            border: 'none', borderRadius: 20, padding: '3px 10px', fontSize: 11,
                            fontWeight: 600, cursor: 'pointer',
                            background: d.kayit_acik !== false ? (isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE') : (isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB'),
                            color:      d.kayit_acik !== false ? '#3B6D11'  : '#A32D2D',
                          }}>
                          {d.kayit_acik !== false ? '● Açık' : '● Kapalı'}
                        </button>
                      </td>
                      <td style={{ padding:'10px 14px', color:isDark ? '#bbb' : '#555', fontSize:12 }}>{d.kayitli_ogrenci}</td>
                      <td style={{ padding:'10px 14px' }}>
                        <div style={{ display:'flex', gap:6 }}>
                          <button onClick={e => { e.stopPropagation(); ac(d); }} style={{ border:`1px solid ${border}`, background:card, padding:'4px 10px', borderRadius:6, cursor:'pointer', fontSize:11 }}>Duzenle</button>
                          <button onClick={e => { e.stopPropagation(); sil(d.id); }} style={{ border:'1px solid #fee', background:'#fff5f5', color:'#e24b4a', padding:'4px 10px', borderRadius:6, cursor:'pointer', fontSize:11 }}>Sil</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      )}

      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'flex-start', justifyContent:'center', zIndex:100, paddingTop:30, overflowY:'auto' }}
          onClick={e => { if (e.target===e.currentTarget) setModal(false); }}>
          <div style={{ background:card, borderRadius:12, padding:24, width:520, marginBottom:40 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:16 }}>{duzenle ? 'Dersi duzenle' : 'Yeni ders ekle'}</div>

            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Ders adi</div>
              <input value={form.ad} onChange={e=>setForm(p=>({...p,ad:e.target.value}))} placeholder="Ornek: Tango Baslangic A"
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:10 }}>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Seviye</div>
                <select value={form.seviye} onChange={e=>setForm(p=>({...p,seviye:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                  {SEVIYELER.map(s=><option key={s}>{s}</option>)}
                </select>
              </div>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Max ogrenci</div>
                <input type="number" value={form.kapasite} onChange={e=>setForm(p=>({...p,kapasite:parseInt(e.target.value)||15}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Salon</div>
                <select value={form.salon_id} onChange={e=>setForm(p=>({...p,salon_id:e.target.value}))}
                  style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
                  <option value="">-- Sec --</option>
                  {salonlar.map(s=><option key={s.id} value={s.id}>{s.ad}</option>)}
                </select>
              </div>
            </div>

            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:4, fontWeight:500 }}>Aciklama (opsiyonel)</div>
              <input value={form.aciklama} onChange={e=>setForm(p=>({...p,aciklama:e.target.value}))} placeholder="Kisa aciklama..."
                style={{ width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #ddd', fontSize:13, boxSizing:'border-box' }} />
            </div>

            <div style={{ marginBottom:10 }}>
              <div style={{ fontSize:11, color:textSec, marginBottom:6, fontWeight:500 }}>Öğrenci kaydı</div>
              <button type="button" onClick={() => setForm(p => ({...p, kayit_acik: !p.kayit_acik}))}
                style={{
                  border: `1px solid ${form.kayit_acik ? '#1D9E75' : '#e24b4a'}`,
                  background: form.kayit_acik ? (isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE') : (isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB'),
                  color: form.kayit_acik ? '#3B6D11' : '#A32D2D',
                  padding: '6px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                }}>
                {form.kayit_acik ? '● Kayıt açık — yeni öğrenci alınıyor' : '● Kayıt kapalı — yeni öğrenci alınmıyor'}
              </button>
            </div>

            <div style={{ borderTop:`1px solid ${border}`, paddingTop:14, marginTop:4 }}>
              <div style={{ fontSize:12, fontWeight:500, marginBottom:10 }}>Egitmenler ve hakedis oranlari</div>
              <div style={{ display:'flex', gap:6, marginBottom:8, flexWrap:'wrap', alignItems:'flex-end' }}>
                <div>
                  <div style={{ fontSize:10, color:textMuted, marginBottom:3 }}>Egitmen</div>
                  <select value={yeniEgitmen.egitmen_id} onChange={e=>setYeniEgitmen(p=>({...p,egitmen_id:e.target.value}))}
                    style={{ padding:'6px 8px', borderRadius:6, border:'1px solid #ddd', fontSize:12, minWidth:160 }}>
                    <option value="">-- Sec --</option>
                    {tumEgitmenler.filter(e=>!dersEgitmenleri.find(de=>de.egitmen_id===e.id)).map(e=>(
                      <option key={e.id} value={e.id}>{e.ad} {e.soyad}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <div style={{ fontSize:10, color:textMuted, marginBottom:3 }}>Hakedis %</div>
                  <input type="number" value={yeniEgitmen.hakedis_oran} onChange={e=>setYeniEgitmen(p=>({...p,hakedis_oran:e.target.value===''?0:parseFloat(e.target.value)}))} min={0} max={100}
                    style={{ width:80, padding:'6px 8px', borderRadius:6, border:'1px solid #ddd', fontSize:12 }} />
                </div>
                <button onClick={egitmenEkle} style={{ padding:'6px 12px', borderRadius:6, border:'none', background:'#534AB7', color:'white', cursor:'pointer', fontSize:12 }}>+ Ekle</button>
              </div>
              {dersEgitmenleri.length>0 && (
                <div style={{ display:'flex', flexWrap:'wrap', gap:5, marginBottom:8 }}>
                  {dersEgitmenleri.map((e,i)=>(
                    <span key={i} style={{ display:'inline-flex', alignItems:'center', gap:5, background:isDark ? 'rgba(83,74,183,0.2)' : '#EEEDFE', color:'#3C3489', borderRadius:20, padding:'4px 12px', fontSize:12 }}>
                      {e.egitmen_adi} - %{e.hakedis_oran}
                      <span onClick={()=>setDersEgitmenleri(p=>p.filter((_,idx)=>idx!==i))} style={{ cursor:'pointer', opacity:.5, fontWeight:700, fontSize:14 }}>x</span>
                    </span>
                  ))}
                </div>
              )}
              {dersEgitmenleri.length===0 && <div style={{ fontSize:11, color:textMuted, marginBottom:8 }}>Henuz egitmen eklenmedi</div>}
            </div>

            <div style={{ borderTop:`1px solid ${border}`, paddingTop:14 }}>
              <div style={{ fontSize:12, fontWeight:500, marginBottom:10 }}>Seanslar</div>
              <div style={{ display:'flex', gap:6, marginBottom:8, flexWrap:'wrap', alignItems:'center' }}>
                <select value={yeniSeans.gun} onChange={e=>setYeniSeans(p=>({...p,gun:e.target.value}))}
                  style={{ padding:'6px 8px', borderRadius:6, border:'1px solid #ddd', fontSize:12 }}>
                  {GUNLER.map(g=><option key={g}>{g}</option>)}
                </select>
                <input type="time" value={yeniSeans.baslangic_saat} onChange={e=>setYeniSeans(p=>({...p,baslangic_saat:e.target.value}))}
                  style={{ padding:'6px 8px', borderRadius:6, border:'1px solid #ddd', fontSize:12 }} />
                <span style={{ color:textMuted }}>--</span>
                <input type="time" value={yeniSeans.bitis_saat} onChange={e=>setYeniSeans(p=>({...p,bitis_saat:e.target.value}))}
                  style={{ padding:'6px 8px', borderRadius:6, border:'1px solid #ddd', fontSize:12 }} />
                <button onClick={seansEkle} style={{ padding:'6px 12px', borderRadius:6, border:'none', background:'#534AB7', color:'white', cursor:'pointer', fontSize:12 }}>+ Ekle</button>
              </div>
              {seanslar.length>0 && (
                <div style={{ display:'flex', flexWrap:'wrap', gap:5 }}>
                  {seanslar.map((s,i)=>(
                    <span key={i} style={{ display:'inline-flex', alignItems:'center', gap:5, background:isDark ? '#222222' : '#f0f0f0', color:isDark ? '#bbb' : '#555', borderRadius:20, padding:'3px 10px', fontSize:11 }}>
                      {s.gun} {s.baslangic_saat}--{s.bitis_saat}
                      <span onClick={()=>setSeanslar(p=>p.filter((_,idx)=>idx!==i))} style={{ cursor:'pointer', opacity:.5, fontWeight:700 }}>x</span>
                    </span>
                  ))}
                </div>
              )}
              {seanslar.length===0 && <div style={{ fontSize:11, color:textMuted }}>Henuz seans eklenmedi</div>}
            </div>

            {hata && <div style={{ background:isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color:'#A32D2D', padding:'8px 12px', borderRadius:6, fontSize:12, marginTop:10 }}>{hata}</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={() => setModal(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${border}`, background:card, cursor:'pointer', fontSize:13 }}>Iptal</button>
              <button onClick={kaydet} disabled={kaydediliyor} style={{ padding:'8px 16px', borderRadius:6, border:'none', background:'#534AB7', color:'white', cursor:'pointer', fontSize:13 }}>
                {kaydediliyor ? 'Kaydediliyor...' : duzenle ? 'Guncelle' : 'Dersi ekle'}
              </button>
            </div>
          </div>
        </div>
      )}
      {arsivModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', display:'flex', alignItems:'flex-start', justifyContent:'center', zIndex:200, paddingTop:40, overflowY:'auto' }}
          onClick={e => { if (e.target===e.currentTarget) setArsivModal(false); }}>
          <div style={{ background:card, borderRadius:12, padding:24, width:720, marginBottom:40 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18 }}>
              <div style={{ fontSize:15, fontWeight:600 }}>Arşivlenen dersler</div>
              <button onClick={() => setArsivModal(false)} style={{ border:'none', background:'none', fontSize:20, cursor:'pointer', color:textMuted }}>×</button>
            </div>
            {arsivYukleniyor ? (
              <div style={{ textAlign:'center', color:textMuted, padding:32 }}>Yükleniyor...</div>
            ) : arsivDersler.length === 0 ? (
              <div style={{ textAlign:'center', color:textMuted, padding:32 }}>Arşivde ders yok.</div>
            ) : (
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                <thead>
                  <tr style={{ borderBottom:`2px solid ${border}` }}>
                    {['Ders','Salon','Eğitmenler','Yoklama','Kayıtlı','Arşivlenme',''].map(h => (
                      <th key={h} style={{ textAlign:'left', padding:'6px 12px', fontSize:11, color:textMuted, fontWeight:500 }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {arsivDersler.map((d, i) => (
                    <tr key={d.id} onClick={() => { setArsivModal(false); navigate(`/dersler/${d.id}`); }} style={{ borderBottom: i < arsivDersler.length - 1 ? `1px solid ${isDark ? '#1c1c1c' : '#f5f5f5'}` : 'none', cursor:'pointer' }}>
                      <td style={{ padding:'10px 12px', fontWeight:500 }}>
                        {d.ad}
                        {d.seviye && <span style={{ marginLeft:6, fontSize:10, background:isDark ? '#222222' : '#f0f0f0', color:isDark ? '#999' : '#666', borderRadius:20, padding:'1px 7px' }}>{d.seviye}</span>}
                      </td>
                      <td style={{ padding:'10px 12px', color:isDark ? '#999' : '#666', fontSize:12 }}>{d.salon_adi||'—'}</td>
                      <td style={{ padding:'10px 12px' }}>
                        <div style={{ display:'flex', flexWrap:'wrap', gap:3 }}>
                          {d.egitmenler?.map((e:any, ei:number) => (
                            <span key={ei} style={{ background:isDark ? 'rgba(83,74,183,0.2)' : '#EEEDFE', color:'#3C3489', borderRadius:20, padding:'1px 7px', fontSize:10 }}>{e.egitmen_adi}</span>
                          ))}
                          {(!d.egitmenler || d.egitmenler.length === 0) && <span style={{ color:isDark ? '#444' : '#ccc', fontSize:11 }}>—</span>}
                        </div>
                      </td>
                      <td style={{ padding:'10px 12px', color:isDark ? '#bbb' : '#555', fontSize:12 }}>{d.yoklama_sayisi} oturum</td>
                      <td style={{ padding:'10px 12px', color:isDark ? '#bbb' : '#555', fontSize:12 }}>{d.kayitli_ogrenci} öğrenci</td>
                      <td style={{ padding:'10px 12px', color:textMuted, fontSize:11, whiteSpace:'nowrap' }}>
                        {d.guncellendi ? new Date(d.guncellendi).toLocaleDateString('tr-TR',{day:'numeric',month:'short',year:'numeric'}) : '—'}
                      </td>
                      <td style={{ padding:'10px 12px' }} onClick={e => e.stopPropagation()}>
                        {(kullanici?.rol === 'super_admin' || !!localStorage.getItem('sube_giren_token_backup')) && (
                          <button onClick={() => kaliciSil(d.id, d.ad)} style={{ border:'1px solid #fee', background:'#fff5f5', color:'#e24b4a', padding:'4px 10px', borderRadius:6, cursor:'pointer', fontSize:11, whiteSpace:'nowrap' }}>
                            Kalıcı sil
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <div style={{ marginTop:16, fontSize:11, color:isDark ? '#555' : '#bbb' }}>
              Kalıcı silme işlemi geri alınamaz. Yoklama kayıtları da silinir.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Dersler;
